import { atom } from 'jotai';

export interface Shelter {
  id: string;
  name: string;
  sold_to: string;
  join_program_date: string;
  created_at: string;
  updated_at: string;
  is_petszel_enabled?: boolean;
  petszel_first_used_at?: string | null;
  preferred_ship_to?: string | null;
  country?: string | null;
}

export interface ShelterLoadingState {
  isLoading: boolean;
  error: string | null;
}

// Create atoms for storing shelter data
export const shelterAtom = atom<Shelter | null>(null);

// Loading state atom
export const shelterLoadingAtom = atom<ShelterLoadingState>({
  isLoading: false,
  error: null,
});
